import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import type { FieldDefinition, FormSchema, FormSection } from '../types'
import { SectionEditorPanel } from './SectionEditorPanel'
import { SectionLayoutEditor } from './SectionLayoutEditor'
import { SectionPreview } from './SectionPreview'

type Props = {
  schema: FormSchema
  section: FormSection
  objectType: string
  onAddField: () => void
  onEditField: (field: FieldDefinition) => void
}

/**
 * Wraps the section's right-pane editor in three views:
 * - "Wizualnie" - {@link SectionLayoutEditor} - DnD grid z kafelkami pól, resize szerokości.
 * - "Lista" - {@link SectionEditorPanel} - tabela z sortem/filtrami/edycją.
 * - "Podgląd" - {@link SectionPreview} - renderuje sekcję tak jak w formularzu kontraktu.
 */
export function SectionEditorWithTabs(props: Props) {
  return (
    <Tabs defaultValue="visual" className="flex-1 flex flex-col gap-0 overflow-hidden">
      <TabsList className="rounded-none w-full justify-start gap-2 px-4 border-b bg-white h-auto">
        <TabsTrigger value="visual">Wizualnie</TabsTrigger>
        <TabsTrigger value="list">Lista</TabsTrigger>
        <TabsTrigger value="preview">Podgląd</TabsTrigger>
      </TabsList>
      <TabsContent value="visual" className="flex-1 overflow-hidden">
        <SectionLayoutEditor {...props} />
      </TabsContent>
      <TabsContent value="list" className="flex-1 overflow-hidden">
        <SectionEditorPanel {...props} />
      </TabsContent>
      <TabsContent value="preview" className="flex-1 overflow-hidden">
        <SectionPreview schema={props.schema} section={props.section} />
      </TabsContent>
    </Tabs>
  )
}
